import Logger from '../../../../ui-kitchen/src/utils/logger';

angular
  .module('resyApp')
  .controller('RedirectCtrl', RedirectCtrl);

function RedirectCtrl($location, $window, REDIRECT_CONFIG) {
  /**
   * 1) Remove first character (should be /)
   * 2) lower case
   * 3) remove all hyphens
   */
  const path = $location.path().slice(1).toLowerCase().replace(/-/g, '');

  if (path in REDIRECT_CONFIG.map) {
    $window.location = REDIRECT_CONFIG.map[path] + $window.location.search; // eslint-disable-line no-param-reassign
  } else {
    Logger.warn(`${path} missing in REDIRECT_CONFIG config.`);
    $location.url('/');
  }
}

export default () => {};
